module.exports = __webpack_public_path__ + "static/media/DH_03.708bddb6.jpg";